import React, { useEffect, useReducer, useState } from "react";
import ReactDOM from "react-dom";
import ReactSelect, { components } from "react-select";
import Button from "./Button";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Modal from "./modal/Modal";
import { Col, Row } from "react-bootstrap";

const MonitorModal = (props) => {
  const monitoring = props.newMonitor.length > 0 ? props.newMonitor : [];

  const params = useParams();
  const isAdded = useSelector((state) => state?.boardAttribute?.isMonitorAdded);
  const isAdding = useSelector((state) => state?.boardAttribute?.isAdding);
  const [monitorModal, setMonitorModal] = useState(null);
  const [propsMonitor, setPropsMonitor] = useState(null);
  const [addMonitor, setAddMonitor] = useState([]);
  const [multiRemove, setMultiRemove] = useState([]);
  const classes = `modal fade ${props.monitor ? "show" : ""}`;
  useEffect(() => {
    setMonitorModal(props);
  }, [props]);

  useEffect(() => {
    try {
      const allmonitor = [...addMonitor, ...monitoring];
      const newfilmonitor = [...new Set(allmonitor)].filter(
        (item) => props.monitor.removeIdMonitoring !== item
      );
      setAddMonitor(newfilmonitor);
    } catch (error) {
      console.log(error.message);
    }
  }, [props.newMonitor]);

  const customStyles = {
    multiValue: (provided) => ({
      ...provided,
      display: "flex",
      alignItems: "center", // Align items center
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#333", // Customize label color if needed
    }),
  };

  useEffect(() => {
    try {
      const users = Object.keys(props?.monitor?.users)
        .filter((ite) => props?.monitor?.users[ite].is_active == 1)
        .map((item) => ({
          label: props?.monitor?.users[item]?.name,
          email: props?.monitor?.users[item]?.email,
          profile_image: props?.monitor?.users[item]?.profile_image,
          value: item,
        }));
      setPropsMonitor(users);
    } catch (error) {
      console.log(error);
    }
  }, [props]);

  const ImageOption = (props) => {
    const { Option } = components;
    const getimage = props.options.find(
      (item) => item.value === props.value
    ).profile_image;

    return (
      <Option {...props}>
        <img
          className="rounded-circle rci"
          style={{ width: "20px", height: "20px" }}
          src={`${
            getimage ||
            "data:image/png;base64,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"
          }`}
        />{" "}
        &nbsp;
        {props.data.label}
      </Option>
    );
  };

  const addMonitorHandler = (dat, evt) => {
    const monitorselect = [...new Set(addMonitor)];
    const multipleRemove = [...multiRemove];
    if (evt.action === "create-option") {
      const addiMonitor = [...addMonitor];
      monitorselect.push(evt.option.value);
      const propsmodalusers = [...propsMonitor];
      propsmodalusers.push({
        label: evt.option.label,
        value: evt.option.value,
      });
      addiMonitor.push(evt.option.value);
      setAddMonitor(addiMonitor);
      setPropsMonitor(propsmodalusers);
    } else if (evt.action === "remove-value") {
      const inde = monitorselect.findIndex(
        (it) => it == evt.removedValue.value
      );
      multipleRemove.push(evt.removedValue.value);
      monitorselect.splice(inde, 1);
      setMultiRemove(multipleRemove);
      setAddMonitor([...new Set(monitorselect)]);
    } else {
      if (Array.isArray(dat)) {
        dat.forEach((item) => monitorselect.push(item.value));
      } else {
        monitorselect.push(dat.value);
      }
      setAddMonitor([...new Set(monitorselect)]);
    }
  };
  const addMonitorSubmit = (event) => {
    event.preventDefault();
    multiRemove.length > 0 && props.removeMonitorHandler(multiRemove);
    addMonitor.length > 0 &&
      props.addingNewMonitorHandler(params.id, addMonitor);
    // setAddMonitor([]);
    setMultiRemove([]);
  };

  const getSelectReactWithUsers = () => {
    let options;
    if (propsMonitor?.length > 0) {
      options = propsMonitor?.map((itt) => ({
        label: itt.label,
        value: itt.value,
        profile_image: itt.profile_image,
      }));
    }
    return (
      <ReactSelect
        options={options}
        components={{ Option: ImageOption }}
        classNamePrefix="monitor"
        value={options?.filter((item) => addMonitor?.includes(item.value))}
        isMulti={true}
        style={customStyles}
        onChange={addMonitorHandler}
        isClearable={false}
      />
    );
  };
  return (
    <Modal show={isAdded} close={props.close} footer-margin="mb-3">
      <div className="main_monitor">
        <div className="child_monitor">
          <div class="monitorInput-box">{getSelectReactWithUsers()}</div>
        </div>
        <div className="child_button">
          <Button
            type="submit"
            text={props.isFalseAdding ? "Adding" : "Add"}
            className="muBtn _blue"
            disabled={props.isFalseAdding}
            onClick={addMonitorSubmit}
            isAdding={props.isFalseAdding}
          />
        </div>
      </div>
    </Modal>
  );
};

const AddMonitorModal = (props) => {
  return ReactDOM.createPortal(
    <MonitorModal
      monitor={props}
      newMonitor={props.newmonitor}
      isFalseAdding={props.isAddingButton}
      close={props.close}
      addingNewMonitorHandler={props.addingNewMonitorHandler}
      removeMonitorHandler={props.removeMonitorHandler}
    />,
    document.getElementById("monitor-modal")
  );
};

export default AddMonitorModal;
